import React, {useState, useEffect} from 'react';
import {
   View,
   ImageBackground,
   Image,
   TouchableOpacity,
   Platform,
} from 'react-native';

export const ImageQuestionHeader = props => {
   return (
      <TouchableOpacity
         onPress={() => {
            props.onClick();
         }}>
         <View
            style={{
               flex: 1,
               //borderRadius: 16,
            }}>
            <ImageBackground
               source={{uri: props.imageURL}}
               style={{
                  width: props.width,
                  height: props.height,
                  alignItems: 'center',
                  justifyContent: 'center',
                  ...Platform.select({
                     web: {
                        resizeMode: 'cover',
                        height: '100%',
                     },
                  }),
               }}>
               <Image
                  source={require('../../assets/maginifier_image.png')}
                  style={{
                     alignItems: 'center',
                     alignSelf: 'center',
                     justifyContent: 'center',
                     height: props.magnifierImageHeight,
                     width: props.magnifierImageWidth,
                  }}
               />
            </ImageBackground>
         </View>
      </TouchableOpacity>
   );
};
